const Alert = ({ type = 'info', message }) => {
    const base =
      type === 'error'
        ? 'bg-red-100 border-red-400 text-red-700'
        : type === 'success'
        ? 'bg-green-100 border-green-400 text-green-700'
        : 'bg-yellow-100 border-yellow-400 text-yellow-800';
  
    return (
      <div className={`${base} border px-4 py-3 rounded relative mb-6`} role="alert">
        <span className="block sm:inline">{message}</span>
      </div>
    );
  };

export default Alert;